import React, { useState, useEffect } from 'react'
import { useQuery } from 'react-query'
import { useForm } from 'react-hook-form';

import Filter from './filter'
import Map from './map'
import List from '../map/list'
import Teaser from './teaser'

import { calculateState } from '../../utils'
import { deburr } from 'lodash'



const TidePredictionsSnapshotApp = ({ bid, endpoint, defaultCentre, defaultZoom, noResultsText, ...settings }) => {

  const { register, handleSubmit, resetField } = useForm();
  const [ filtered, setFiltered ] = useState(null);

  const [ filters, setFilters ] = useState({
    keywords: '',
    type: '',
    //district: '',
    //stage: ''
  })

  const [ mapDefaults, setMapDefaults ] = useState({
    defaultCentre,
    defaultZoom
  })

    const { isLoading, error, data } = useQuery(`tide-predictions-${bid}`, async () => {
        return await fetch(`/api/v2/tp?token=${settings.token}`, {
          headers: new Headers({
            'content-type': 'application/json'
          })
        }).then(async res => {
          if(res.ok) {
            return await res.json()
          }
          throw await res.json();
        }).then(items => {
          return items.filter(item => {
            if(!item.location) {
              return false;
            }
            return item;
          }).map(item => {

            return {
              ...item,
              status: item.status === 'offset' ? 'offset' : 'prediction',
              latitude: item.location[0],
              longitude: item.location[1],
            }
          })
        })
        .then(items => items.map(item => ({
          ...item,
          isCloseToAntimeridian: item.longitude < -175
        })))
      }
    )

    useEffect(() => {
      if(data && data.length) {
        setFiltered(data);
      }
    }, [data]);

    useEffect(() => {
      if(!data) {
        return;
      }
      let clone = [...data];
      if(filters?.keywords.length > 2) {
        // do filtering
        let keywords = deburr(filters.keywords).toLowerCase();
        clone = clone.filter(({ title }) => deburr(title).toLowerCase().includes(keywords.toLowerCase()))
      }
      if(filters?.type) {
        console.log(clone);
        clone = clone.filter(({ status }) => status === filters.type)
      }

      setFiltered(clone);
    }, [filters]);


    if(isLoading) {
        return <div className="spinner">&nbsp;</div>;
    }

    if(data.length === 0) {
      return <div className="linz-map-snapshot__no-results">{noResultsText}</div>
    }



    const types = [...new Set(data.map(({ field_tide_type }) => field_tide_type))].filter(item => item);

    const onFilter = ({ keywords, type }) => {

      console.log(type)

      setFilters({
        keywords: keywords || '',
        type: type || ''
      });
    }


    const onReset = () => {
      setFiltered(data);
      resetField('keywords')
      resetField('type')
      setFilters({
        keywords: '',
        type: ''
      })
      setMapDefaults({
        defaultCentre,
        defaultZoom
      })
    }

    const years  = [settings.start, ...Array.from({length: (settings.end - settings.start)},(v,k)=> {
      return settings.start + (k+1)
    })]

    let role = filters.keywords !== '' || filters.type !== '' ? 'status' : '';

    return (

      <div className="tide-predictions-map__app map__app">

        <Filter
          id={bid}
          types={types}
          register={register}
          handleSubmit={handleSubmit(onFilter)}
          onReset={onReset}
          filters={filters}
          {...settings}
        />
        {filtered && (
          <div className="map__controls" role={role}>
            <h3>{`Showing ${filtered.length} location${filtered.length === 1 ? '' : 's'}`}</h3>
          </div>
        )}
        {filtered && <List years={years} data={filtered} Elem={Teaser} {...settings} />}
        {filtered && mapDefaults && <Map years={years} data={filtered} {...mapDefaults} {...settings} />}
      </div>
    )
}
export default TidePredictionsSnapshotApp
